/**
 * Tempo relativo curto pra notificações ("agora", "5min", "2h", "3d").
 * A partir de 7 dias mostra data absoluta (dd/mm/aaaa) — mais legível que "45d"
 * na página de histórico completo.
 *
 * `now` é injetável pra testes determinísticos.
 */
export function timeAgo(ms?: number, now: number = Date.now()): string {
  if (!ms) return '';
  const diff = now - ms;
  if (diff < 0) return 'agora'; // timestamp futuro / clock skew

  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return 'agora';
  if (minutes < 60) return `${minutes}min`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'America/Sao_Paulo',
  }).format(new Date(ms));
}
